/* eslint-disable react/prop-types */
import { TextField } from '@/components/ui/TextField'
import StepHeading from '../../StepHeading'
// import { RadioGroup, RadioGroupItem } from '@/components/ui/RadioGroup'
// import { Label } from '@/components/ui/Label'
// import { BUDGETING_PERIODS } from '@/data/constants/constants'
import { useForm } from 'react-hook-form'
import useSetupStore from '@/store/useSetupStore'
import { useEffect } from 'react'
import { isValidAbn } from '@/utils/abn'
// import ErrorLabel from '@/components/ErrorLabel'

export default function AboutYourBusiness({ form: _form }) {
  let form = useForm()
  form = _form

  const data = useSetupStore((state) => state.getData)()
  // const { field } = useController({
  //   control: form.control,
  //   name: 'budgetingPeriod',
  //   rules: { required: 'Please select a period' },
  //   shouldUnregister: true,
  //   defaultValue: data?.budgetingPeriod,
  // })

  useEffect(() => {
    form.setValue('name', data?.name ?? '')
    form.setValue('abn', data?.abn ?? '')
  }, [data, form])

  const { errors } = form.formState

  return (
    <div>
      <StepHeading>About your business</StepHeading>

      <TextField
        status={errors?.name ? 'error' : ''}
        statusText={errors?.name?.message ?? null}
        large
      >
        <TextField.Label>Business Name</TextField.Label>
        <TextField.Input
          placeholder="For example: JohnDeer "
          {...form.register('name', {
            required: 'The name field is required.',
            shouldUnregister: true,
          })}
        />
      </TextField>

      <div className="mt-5">
        <TextField
          status={errors?.abn ? 'error' : ''}
          statusText={errors?.abn?.message ?? null}
          large
        >
          <TextField.Label>ABN (optional)</TextField.Label>
          <TextField.Input
            placeholder="11 digits, e.g. 51 824 753 556"
            inputMode="numeric"
            {...form.register('abn', {
              validate: (value) =>
                !value?.trim() ||
                isValidAbn(value) ||
                'Enter a valid 11-digit ABN',
              shouldUnregister: true,
            })}
          />
        </TextField>
      </div>

      <p className="mt-4 text-sm text-txt-secondary">
        Your business name and ABN will be used for billing and appear on your
        tax invoices. You can change them later in Space Settings.
      </p>

      {/* <div className="mt-5">
        <Label>Budgetting period</Label>

        <RadioGroup
          className=" mt-3 grid grid-cols-2 gap-2"
          onValueChange={field.onChange}
          defaultValue={field.value}
        >
          {Object.entries(BUDGETING_PERIODS).map(([key, value]) => (
            <Label
              key={key}
              className="group h-[164px] rounded-lg  bg-gray-low p-4 hover:cursor-pointer"
            >
              <div className="flex items-start gap-2 " data-state="checked">
                <div className="leading-none">
                  <RadioGroupItem value={value} />
                </div>
                <div className="leading-none">
                  <p className="capitalize text-txt-primary">{value}</p>
                  <p className="mt-2 text-sm text-txt-secondary">
                    Text about what is Budgeting period and which one is better
                    to choose
                  </p>
                </div>
              </div>
            </Label>
          ))}
        </RadioGroup>

        <ErrorLabel
          text={errors?.budgetingPeriod?.message ?? null}
          className="mt-1"
        />
      </div> */}
    </div>
  )
}
